import "./tips.css";
import Seo from "../../components/seo/Seo";

const tips = [
    {
        title: "Breda Wandelt",
        image: require("../../static/afbeeldingen/breda_wandelt.png"),
        alt: "Breda Wandelt",
        paragraphs: [
            "Door 2 enthousiaste dames is er een mooi initiatief gestart: Breda Wandelt. Hoe leuk is het om met anderen op stap te gaan om de prachtige plekjes in en rondom Breda te ontdekken, in beweging te zijn en met onbekenden in contact te komen.",
            "Naast de wandelingen in de natuur zijn er ook routes waar u een stukje cultuur opsnuift en de begeleiders van alles vertellen over bijzondere plekjes die aangedaan worden.",
            "De wandelingen zijn geschikt voor beginners en gevorderden en zijn 5 tot 8 km lang. Er is ook altijd tijd voor een drankje en of versnapering.",
        ],
        href: "https://www.breda-wandelt.nl",
        label: "www.breda-wandelt.nl",
    },
    {
        title: "hart for her",
        image: require("../../static/afbeeldingen/hartforher.png"),
        alt: "hart for her",
        paragraphs: [
            "Voor iedere vrouw die zich fit en zeker wil voelen.",
            "hart for her is een trainingsprogramma speciaal voor vrouwen en erop gericht om u energieker, fitter en zekerder te laten voelen. In 30 minuten doorloopt u een circuit op eigen niveau, zonder spierpijn of blessure.",
            "Leden omschrijven hart for her als een plek waar je echt jezelf kunt zijn. Investeer in uw gezondheid, voor nu en later.",
        ],
        href: "https://www.hartforher.nl/vestigingen/vrouwen-sport-fitness-afvallen-breda",
        label: "www.hartforher.nl",
    },
    {
        title: "Praktijk voor Integrale Geneeskunde West-Brabant",
        image: require("../../static/afbeeldingen/praktijk-geneeskunde.png"),
        alt: "Praktijk voor Integrale Geneeskunde",
        paragraphs: [
            "Bij Mesologie staat het begrijpen van uw klachten en de achterliggende oorzaak centraal. Een mesoloog behandelt een groot scala aan gezondheidsklachten voor iedereen, van jong tot oud.",
            "Wilt u een effectief gezondheidsplan specifiek voor uw klacht waarbij de zelfgenezende kracht van het menselijk lichaam gerespecteerd wordt, kies dan voor Mesologie.",
        ],
        href: "https://www.mesoloog.info/nl-nl/",
        label: "www.mesoloog.nl",
    },
];

export default function Tips() {
    return (
        <>
            <Seo
                title="Tips en inspiratie"
                description="Ontdek tips, lokale initiatieven en inspirerende adressen rond beweging en gezondheid in Breda."
                path="/tips"
            />

            <section className="page-intro">
                <p className="section-label">Tips</p>
                <h1>Lokale tips die passen bij een actieve en gezonde leefstijl.</h1>
                <p>
                    Inspiratie voor beweging, gezondheid en ondersteuning in en rond Breda.
                </p>
            </section>

            <section className="tips-list">
                {tips.map((tip, index) => (
                    <article
                        className={`tip-card ${index % 2 === 1 ? "tip-card--reverse" : ""}`}
                        key={tip.title}
                    >
                        <div className="tip-card__content">
                            <h2>{tip.title}</h2>
                            {tip.paragraphs.map((paragraph) => (
                                <p key={paragraph}>{paragraph}</p>
                            ))}
                            <a href={tip.href} target="_blank" rel="noreferrer">
                                {tip.label}
                            </a>
                        </div>
                        <div className="tip-card__image">
                            <img src={tip.image} alt={tip.alt} />
                        </div>
                    </article>
                ))}
            </section>
        </>
    );
}
